import gql from "graphql-tag";

export const MY_TIME_SUBSCRIPTION = gql`
  subscription myTimeSubscription {
    myTimeSubscription
  }
`;
